import _slicedToArray from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\slicedToArray.js";
import cn from 'classnames';
import React from 'react';
import { useListOption } from './FocusListContext';

function MultiselectTag(_ref) {
  var className = _ref.className,
      children = _ref.children,
      style = _ref.style,
      label = _ref.label,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      onRemove = _ref.onRemove,
      clearTagIcon = _ref.clearTagIcon,
      dataItem = _ref.dataItem;

  var _useListOption = useListOption(dataItem),
      _useListOption2 = _slicedToArray(_useListOption, 3),
      ref = _useListOption2[0],
      focused = _useListOption2[1],
      id = _useListOption2[2];

  var handleRemove = function handleRemove(event) {
    if (!disabled) onRemove(dataItem, event);
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    role: "option",
    id: id,
    "data-rw-option": "",
    "data-rw-focusable": disabled ? undefined : '',
    "data-rw-focused": focused ? '' : undefined,
    className: cn(className, 'rw-multiselect-tag', disabled && 'rw-state-disabled', focused && !disabled && 'rw-state-focus'),
    style: style
  }, /*#__PURE__*/React.createElement("span", {
    className: "rw-multiselect-tag-label"
  }, children), /*#__PURE__*/React.createElement("button", {
    type: "button" // these should not be tabbable
    ,
    tabIndex: -1,
    onClick: handleRemove,
    onTouchEnd: handleRemove,
    disabled: disabled || readOnly,
    className: "rw-multiselect-tag-btn",
    "aria-label": label || 'Remove item'
  }, clearTagIcon));
}

export default MultiselectTag;